<template>
  <div
    class="app-circle-btn"
    :class="rootClass"
    @click="handlerClick"
    v-bind="$attrs"
  >
    <button class="app-circle-btn__btn" type="button">
      <slot name="icon">
        <app-svg-icon
          :style="styleObject"
          class="app-circle-btn__icon"
          isCurrentColor
          :name="nameIcon"
        ></app-svg-icon>
      </slot>
    </button>
    <div v-if="isText" class="app-circle-btn__text">
      <slot>Добавить</slot>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppCircleBtn',
  components: {
    AppSvgIcon: () => import('@/components/common/AppSvgIcon'),
  },
  props: {
    isText: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: 'default', // 'secondary' || 'link'
    },
    color: {
      type: String,
      default: 'gray',
    },
    nameIcon: {
      type: String,
      default: 'close',
    },
    size: {
      type: String,
      default: 'normal',
    },
    width: {
      type: String,
      default: '',
    },
    height: {
      type: String,
      default: '',
    },
  },
  computed: {
    styleObject() {
      if (this.width || this.height) {
        return {
          width: this.width,
          height: this.height,
        };
      }
      return {};
    },
    /**
     * Основной класс кнопки
     */
    rootClass() {
      return [
        {
          'app-circle-btn--green': this.color === 'green',
          'app-circle-btn--red': this.color === 'red',
          'app-circle-btn--add': this.type === 'add',
          'app-circle-btn--remove': this.type === 'remove',
          'app-circle-btn--check': this.type === 'check',
          'app-circle-btn--large': this.size === 'large',
          'app-circle-btn--largest': this.size === 'largest',
          'app-circle-btn--small': this.size === 'small',
          'app-circle-btn--no-text': !this.isText,
        },
      ];
    },
  },
  methods: {
    /**
     * Отправка родителю события клика
     * @param event
     */
    handlerClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="scss">
.app-circle-btn {
  $this: &;

  display: flex;
  align-items: center;
  color: #cbcbcb;
  cursor: pointer;
  transition: color $A;

  &:hover {
    color: darken(#cbcbcb, 10%);
  }

  &__btn {
    @include button-reset;
    @include size(32px);

    display: flex;
    flex-shrink: 0;
    align-items: center;
    margin-right: 15px;
    color: currentColor;
    border: 1px solid currentColor;
    border-radius: 50%;
  }

  &__icon {
    @include size(7px);

    margin: auto;
    color: currentColor;
    stroke: none !important;
  }

  &__text {
    font-weight: 300;
  }
  // size
  &--largest {
    #{$this}__btn {
      @include size(50px);
    }

    #{$this}__icon {
      @include size(12px);
    }
  }

  &--large {
    #{$this}__btn {
      @include size(40px);
    }

    #{$this}__icon {
      @include size(10px);
    }
  }

  &--small {
    #{$this}__btn {
      @include size(26px);

      margin-right: 10px;
    }
  }
  //
  &--no-text {
    #{$this}__btn {
      margin-right: 0;
    }
  }

  &--add {
    #{$this}__icon {
      transform: rotate(45deg);
    }
  }

  &--check {
    #{$this}__icon {
      color: $color-brand-green;
    }
  }
  // color
  &--green {
    color: $color-brand-green;

    &:hover {
      color: darken($color-brand-green, 10%);
    }
  }

  &--red {
    color: $color-red;

    &:hover {
      color: darken($color-red, 10%);
    }
  }
}
</style>
